import React from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { BASE_IMG_URL } from '@images/imageUrls';
import classNames from 'classnames';

interface H5CommonAlertProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    // 是否显示取消按钮
    isShowCancel?: boolean;
    // 是否显示确定按钮
    isShowConfirm?: boolean;
    // 是否显示
    visible: boolean;
     // 显示隐藏
    onHidePopup?: Function
    // 标题
    title?: string;
    // 提示内容
    text?: any
    textsub?: any 
    // 使用richtext解析
    useRichtext?: boolean
    // richtext内容
    richtextContent?: any
    // 取消事件
    onCancelChange?: Function
    // 确定事件
    onConfirmButtonChange?: Function
    // 取消按钮文字
    cancelText?: string
    // 确定按钮文字
    confirmText?: string
    // 确定按钮不可点击状态
    confirmDisabled?: boolean
    // 插槽相关属性
    children?: React.ReactNode; // 内容插槽
}

@inject('app', 'site', 'user')
@observer
class H5CommonAlert extends React.Component<H5CommonAlertProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
    }
    // 隐藏
    onHidePopup = () => {
        this.props.onHidePopup && this.props.onHidePopup()
    }

    render() {
        let { isShowCancel = true, isShowConfirm = true, visible, title, text, textsub,  richtextContent = '', cancelText = '取消', confirmText = '确认', confirmDisabled = false, children } = this.props
        return <>
            <div className={classNames(styles.popupBox, visible ? styles.openPopup : '')}>
                <div className={classNames(styles.popupMask)} onClick={this.onHidePopup}></div>
                <div className={classNames(styles.popupContent)}>
                    <div className={styles.popupTitleBox}>
                        <div className={classNames(styles.popupTitle)}>{title || '提示'}</div>
                    </div>
                    {text !== '' && <div className={styles.popupTextBox}>
                        <div className={styles.popupText}>{text}</div>
                        <div className={styles.popupText}>{textsub}</div>
                    </div>}
                    {children && <div className={styles.childrenSlot}>
                        {children}
                    </div>}

                    {/* {(useRichtext && !!richtextContent) && <RichText nodes={richtextContent} style={' word-break: break-all;'} ></RichText>} */}

                    {
                        (!!isShowCancel && !!!isShowConfirm) && <div className={classNames(styles.popupBtnBox, styles.onlyOneBtn)}>
                            <div className={styles.cancelButton} style={{flex:1, margin: 0}} onClick={() => {
                                this.props.onCancelChange && this.props.onCancelChange()
                            }}>{cancelText}</div>
                        </div>
                    }
                    {
                        (!!!isShowCancel && !!isShowConfirm) && <div className={classNames(styles.popupBtnBox, styles.onlyOneBtn)}>
                            <div className={classNames(styles.confirmButton, confirmDisabled ? styles.disabledConfirmBtn : '')} style={{flex:1, margin: 0}} onClick={(e) => {
                                if(!confirmDisabled) {
                                    this.props.onConfirmButtonChange && this.props.onConfirmButtonChange()
                                }
                            }}>{confirmText}</div>
                        </div>
                    }
                    {
                        (!!isShowCancel && !!isShowConfirm) && <div className={classNames(styles.popupBtnBox)}>
                            <div className={styles.cancelButton} onClick={() => {
                                this.props.onCancelChange && this.props.onCancelChange()
                            }}>{cancelText}</div>
                            <div className={classNames(styles.confirmButton, confirmDisabled ? styles.disabledConfirmBtn : '')} onClick={(e) => {
                                if(!confirmDisabled) {
                                    this.props.onConfirmButtonChange && this.props.onConfirmButtonChange()
                                }
                            }}>{confirmText}</div>
                        </div>
                    }
                    
                </div>
            </div>
        </>;
        
    }
}

export default H5CommonAlert;